import { BaseFeature, FeatureType } from '@core/shared/feature';
export class HealthInsurancesBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@common/health-insurances/feature","featureId":"common-health-insurances"},
      bundledItemModels: ["HealthInsuranceItem"],
      // list is auto-generated by generate-model-ids
      abilityActions: false,
      dependencies: [],
      plugins: [
      // {forPlatform:'frontend', type:FeatureType.Permanent, pluginClassName:'HealthInsurancesFrontendFeature'},
      // {forPlatform:'frontend-management', type:FeatureType.Dynamic, pluginClassName:'HealthInsurancesFrontendManagementFeature', simpleAbilityCheck:'MANAGER' },
      {
        forPlatform: 'admin',
        type: FeatureType.Permanent,
        pluginClassName: 'HealthInsurancesFrontendAdminFeature'
      }, {
        forPlatform: 'backend',
        type: FeatureType.Permanent,
        pluginClassName: 'HealthInsurancesBackendFeature'
      }, {
        forPlatform: 'backend-admin',
        type: FeatureType.Permanent,
        pluginClassName: 'HealthInsurancesBackendAdminFeature'
      }]
    };
  }
  getSharedDefinition() {
    return {
      routerLinkResolvers: {
        frontend: {}
      }
    };
  }
}